var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visit-aaci-summary"},[_c('VitalSignsSummary',{attrs:{"readings":_vm.visit.vitalSigns || []}}),(_vm.visit.ackDt)?_c('div',{staticClass:"description text-muted"},[_vm._v(" แพทย์รับทราบก่อนรักษา "+_vm._s(_vm.ackName)+" "+_vm._s(_vm.time(_vm.visit.ackDt))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }